export default "__VITE_ASSET__C6rnNi6e__"